import { render, staticRenderFns } from "./ClientConsolidation.vue?vue&type=template&id=5e33b3e0&scoped=true"
import script from "./ClientConsolidation.vue?vue&type=script&lang=js"
export * from "./ClientConsolidation.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5e33b3e0",
  null
  
)

export default component.exports